import React, { useState } from 'react';
import BoatList from '../Boat/BoatList';
import ScanViewer from '../Scan/ScanViewer';
import ScanHistory from '../Scan/ScanHistory';
import DocumentList from '../Document/DocumentList';
import DocumentViewerModal from '../Document/DocumentViewerModal';

const UserDashboard = ({ user, selectedBoat, setSelectedBoat, selectedScan, setSelectedScan, onBoatViewed }) => {
  const [viewingDocument, setViewingDocument] = useState(null);
  const [showGuestDocumentMessage, setShowGuestDocumentMessage] = useState(false);

  // Check if the current user is the owner of the selected boat
  const isOwner = selectedBoat ? user.boats.some(boat => boat.id === selectedBoat.id) : false;

  const handleSelectDocument = (document) => {
    if (isOwner) {
      setViewingDocument(document);
    } else {
      setShowGuestDocumentMessage(true);
      setTimeout(() => setShowGuestDocumentMessage(false), 5000); // Hide message after 5 seconds
    }
  };

  const handleCloseDocumentViewer = () => {
    setViewingDocument(null);
  };

  const handleSelectBoat = (boat) => {
    setSelectedBoat(boat);
    // Only increment view count if the user is the owner
    if (user.boats.some(b => b.id === boat.id)) {
       onBoatViewed(user.id, boat.id); // Call the function to increment view count
    }
  };


  return (
    <div className="p-6 space-y-8">
      {!selectedBoat ? (
        <BoatList boats={user.boats} onSelectBoat={handleSelectBoat} />
      ) : !selectedScan ? (
        <div className="space-y-6">
          <button
            onClick={() => setSelectedBoat(null)}
            className="flex items-center text-blue-600 hover:text-blue-800 font-medium"
          >
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver a mis embarcaciones
          </button>
          <ScanHistory
            scans={selectedBoat.scans}
            onSelectScan={setSelectedScan}
          />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setSelectedScan(null)}
              className="flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Volver al historial
            </button>
            <h2 className="text-xl font-semibold text-gray-900">
              Escaneo del {selectedScan.date}
            </h2>
          </div>
          <ScanViewer embedCode={selectedScan.embedCode} />
          {/* Pass isGuest prop based on ownership */}
          <DocumentList documents={selectedScan.documents} onSelectDocument={handleSelectDocument} isGuest={!isOwner} />
           {/* Show message if not owner */}
           {!isOwner && (
            <p className="mt-4 text-sm text-gray-600">
              Para acceder a estos documentos, por favor contacta a <a href="mailto:contacto@samins.pe" className="text-blue-600 hover:underline">contacto@samins.pe</a>.
            </p>
          )}
        </div>
      )}

      <DocumentViewerModal document={viewingDocument} onClose={handleCloseDocumentViewer} />
    </div>
  );
};

export default UserDashboard;

// DONE